import { Dropdown } from '@creditsights/styleguide-web';
import { DropdownProps } from '@creditsights/styleguide-web/components/Dropdown/Dropdown.types';
import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import styles from './FormDropdown.module.scss';

const cx = classNames.bind(styles);

export const FormDropdown = (props: DropdownProps): ReactElement => (
  <Dropdown
    className={cx('body')}
    search
    searchInput={{ maxLength: 200 }}
    clearable
    withCaretIcon
    withCheckmarks
    {...props}
  />
);
